import Button from "@commons/Button";
import TextInput from "@commons/Input/Text";
import Text from "@commons/Typography/Text";
import SearchIcon from "@mui/icons-material/Search";

type DevicesFilterProps = {
  filterValue: string;
  onChange: (field: string, value: string) => void;
  onApply: () => void;
};

function DevicesFilter({ filterValue, onChange, onApply }: DevicesFilterProps) {
  return (
    <div>
      <div className="grid grid-cols-1 xs:grid-cols-3 lg:grid-cols-6 2xl:grid-cols-8 gap-4 w-full">
        <div className="w-full sm:min-w-36 xs:col-span-2">
          <TextInput
            textSize="sm"
            value={filterValue}
            placeholder="Digite o número do dispositivo"
            fullWidth
            onChange={(e) => onChange("number", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onApply();
            }}
          />
        </div>

        <div className="w-full flex items-end col-span-1 xs:col-span-1">
          <Button
            startIcon={<SearchIcon />}
            customVariant="primary"
            size="full"
            onClick={onApply}
          >
            <Text>Filtrar</Text>
          </Button>
        </div>
      </div>
    </div>
  );
}
export default DevicesFilter;
